"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HorizontalLine = exports.Title = exports.ModalHeader = exports.ModalBodyContainer = exports.ModalBackgroundWrapper = exports.IconContainer = exports.ModalContentWrapper = exports.ModalWrapper = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const colors_1 = require("../../../theme/colors");
exports.ModalWrapper = styled_components_1.default.div `
  height: fit-content;
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 11;
  display: flex;
`;
exports.ModalContentWrapper = styled_components_1.default.div `
  background: white;
  width: calc(100% - 48px);
  height: calc(100vh - 48px);
  margin: 24px;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 12px;
    height: 0.5em;
  }

  &::-webkit-scrollbar-thumb {
    background: ${colors_1.GREY2};
    border-radius: 22px;
  }
`;
exports.IconContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: row-reverse;
  padding: 15px 20px 7px 0px;
  position: sticky;
  top: 0;
`;
exports.ModalBackgroundWrapper = styled_components_1.default.div `
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  padding-top: 80px;
  justify-content: center;
  background-color: ${colors_1.BLACK};
  opacity: 0.7;
  z-index: 10;
`;
exports.ModalBodyContainer = styled_components_1.default.div `
  padding: 0px 6.7% 160px 4.5%;
`;
exports.ModalHeader = styled_components_1.default.div `
  padding: 0px 6.7% 16px 5.6%;
`;
exports.Title = styled_components_1.default.span `
  font-family: SwegonBrown;
  font-style: normal;
  font-weight: bold;
  font-size: 36px;
  line-height: 30px;

  ${(props) => props.$inlineTranslation &&
    (0, styled_components_1.css) `
      label {
        font-weight: bold;
        font-size: 36px;
        line-height: 30px;
      }
    `}
`;
exports.HorizontalLine = styled_components_1.default.hr `
  margin-top: 16px;
  background: ${colors_1.SWEGON_GREEN};
  border: 1px solid ${colors_1.LIGHT_GREY};
`;
//# sourceMappingURL=SettingsModal.styles.js.map